import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import styles from "../../styles/Home/InfoSalud.module.css"; // Importación de estilos con CSS Modules


const articles = [
  {
    title: "Título del artículo",
    description: "Lorem ipsum dolor sit amet. commodo. Sed a fringilla lacus.",
    image: require("../../assets/Images/fondodoc365a.png"), // Reemplazar con la imagen real
  },
  {
    title: "Título del artículo",
    description: "Lorem ipsum dolor sit amet. commodo. Sed a fringilla lacus.",
    image: require("../../assets/Images/fondodoc365a.png"), // Reemplazar con la imagen real

  },
  {
    title: "Título del artículo",
    description: "Lorem ipsum dolor sit amet. commodo. Sed a fringilla lacus.",
    image: require("../../assets/Images/fondodoc365a.png"), // Reemplazar con la imagen real

  },
];

const News = () => {
    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        prevArrow: <button className="slick-prev">&#10094;</button>,
        nextArrow: <button className="slick-next">&#10095;</button>,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      };

  return (
      <div>
        <h2 className="title">Novedades</h2>
    <div className="carousel-container">
    <Slider {...settings}>
      {articles.map((article, index) => (
        <div key={index} className="card">
          <img src={article.image} alt={article.title} />
          <div className="card-content">
            <h3 className="card-title">{article.title}</h3>
            <p className="card-description">{article.description}</p>
          </div>
        </div>
      ))}
    </Slider>
  </div>
  </div>

  );
};

export default News;
